import useFCSubscriptionStore from "@hsl/fc-subscription/store";
import { type StepName, type User } from "@hsl/fc-subscription/types";

import { FlowStepper } from "./FlowStepper";

interface Props {
    mode: "subscribe" | "watch";
}

export const ShareFlow = ({ mode }: Props) => {
    const user = useFCSubscriptionStore((state) => state.user);
    const { steps, finalStepMode, defaultStep } = getFlowProps(user, mode);

    return (
        <FlowStepper
            steps={steps}
            defaultStep={defaultStep}
            finalStepMode={finalStepMode}
            type="share"
        />
    );
};

function getFlowProps(user: User | null, mode: Props["mode"]) {
    const steps: StepName[] = user
        ? mode === "subscribe"
            ? ["select-funds", "add-recipient", "select-documents"]
            : ["select-funds", "add-recipient"]
        : mode === "subscribe"
          ? [
                "select-funds",
                "add-details",
                "verify-email",
                "add-recipient",
                "select-documents",
            ]
          : ["select-funds", "add-details", "verify-email", "add-recipient"];

    const finalStepMode = user ? ("submit" as const) : ("hide" as const);
    const defaultStep: StepName = user ? "add-recipient" : "add-details";
    return { steps, finalStepMode, defaultStep };
}
